var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPedidos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.95833V11.0833H11.6667V15.0417H4.16667V3.95833H15.8333ZM15.8333 2.375H4.16667C3.25 2.375 2.5 3.0875 2.5 3.95833V15.0417C2.5 15.9125 3.25 16.625 4.16667 16.625H12.5L17.5 11.875V3.95833C17.5 3.0875 16.75 2.375 15.8333 2.375ZM10 11.0833H5.83333V9.5H10V11.0833ZM14.1667 7.91667H5.83333V6.33333H14.1667V7.91667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedidos);
export default __webpack_public_path__ + "static/media/Pedidos.165b4fa4b21c6d7f6d6a53c6d5e79cf3.svg";
export { ForwardRef as ReactComponent };